import { h, Component } from 'preact';

import TextField from './field_types/text_field';
import MultipleChoiceField from './field_types/multiple_choice_field';
import MultipleChoiceFieldNoLabel from './field_types/multiple_choice_field_nolabel';
import DatePickerField from './field_types/date_picker_field';
import CheckboxField from './field_types/checkbox_field';
import TextAreaField from './field_types/text_area_field';
import RadioButtonField from './field_types/radio_button_field';
import CheckboxList from './field_types/checkbox_list';

export default class FieldTypeRenderer {
	renderField = (updateValue, field, responses) => {
    console.log([updateValue, field, responses]);
		switch(field.type) {
			case 'label':
				return null;
			case 'text':
				return <TextField field={field} response={responses[field.mapping]} updateValue={updateValue} isValid={(responses[field.mapping].validationErrors.length === 0)} />;
			case 'multiple-choice':
				return <MultipleChoiceField field={field} response={responses[field.mapping]} updateValue={updateValue} isValid={(responses[field.mapping].validationErrors.length === 0)} />;
				case 'multiple-choice-nolabel':
					return <MultipleChoiceFieldNoLabel field={field} response={responses[field.mapping]} updateValue={updateValue} isValid={(responses[field.mapping].validationErrors.length === 0)} />;
			case 'date-picker':
				return <DatePickerField field={field} response={responses[field.mapping]} updateValue={updateValue} isValid={(responses[field.mapping].validationErrors.length === 0)} />;
      case 'checkbox':
        return <CheckboxField field={field} response={responses[field.mapping]} updateValue={updateValue} isValid={(responses[field.mapping].validationErrors.length === 0)} />;
      case 'text-area':
        return <TextAreaField field={field} response={responses[field.mapping]} updateValue={updateValue} isValid={(responses[field.mapping].validationErrors.length === 0)} />;
			case 'checkbox-list':
				return <CheckboxList field={field} response={responses[field.mapping]} updateValue={updateValue} isValid={(responses[field.mapping].validationErrors.length === 0)} />;
			case 'radio-buttons':
				return <RadioButtonField field={field} response={responses[field.mapping]} updateValue={updateValue} isValid={(responses[field.mapping].validationErrors.length === 0)} />;
		}
		return <div>Unmapped field type</div>;
	}
}



// WEBPACK FOOTER //
// ./field_type_renderer.js